import { forwardRef } from "react";
import { useTranslation } from 'react-i18next';
import { FinancialReportItem } from "store/settings/types";
interface PdfProps {
    data: FinancialReportItem [],
    currentDate: string,
    priorDate: string,
    companyName: string
}
export const GenerateBS = forwardRef<HTMLDivElement, PdfProps>(
    (payload, ref,) => {
    const { t } = useTranslation('components.GenerateBS');

    const formatAmount = (amount: number) => {
                if (amount === null || amount === undefined) return '$0.00';
                const isNegative = amount < 0;
                const formatted = Math.abs(amount).toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
                return isNegative ? `($ ${formatted})` : `$ ${formatted}`;
            };

            const getIndentClass = (reportCode: string) => {
                if (reportCode === 'VP') return 'indent-3';
                if (reportCode === 'SSH' || reportCode === 'SST') return 'indent-2';
                if (reportCode === 'SH' || reportCode === 'ST') return 'indent-1';
                return '';
            };

            const getRowClass = (reportCode: string) => {
                if (reportCode === 'GT') return 'grand-total ';
                if (reportCode === 'ST') return 'total-line';
                if (reportCode === 'SST') return 'total-line';
                if (reportCode === 'GH') return 'section-header';
                if (reportCode === 'SH') return 'subsection-header';
                if (reportCode === 'SSH') return 'subsubsection-header';
                return 'line-item';
            };

            const renderRow = (item: FinancialReportItem, index: number) => {
                const { account_chart, total_amount, prev_year_total_amount } = item;
                const rowClass = getRowClass(account_chart.report_code);
                const indentClass = getIndentClass(account_chart.report_code);
                return (
                    <div className={`row ${indentClass === "indent-3" && !total_amount  ? "d-none": "block"}`} key={index}>
                        <div className={`col-4 ${rowClass === "line-item" && rowClass} fw-bold ${indentClass} `}>
                            {account_chart.name}
                        </div>
                        <div className={` ${['section-header',"subsection-header" , "subsubsection-header"].includes(rowClass)  && " invisible"} col-4 text-center  amount `}>
                          
                         <div className=' row'>
                        <div className={` ${ indentClass === "indent-3" ? "block" :" invisible"} col-3`}>  {total_amount !== null ? formatAmount(total_amount) : 0}</div>
                        <div className={` ${ ["indent-2"].includes(indentClass) ? "block" :" invisible"} ${rowClass} col-3`}>
                        {total_amount !== null ? formatAmount(total_amount) : ''}
                        </div>
                        <div className={` ${ ["indent-1"].includes(indentClass) ? "block" :" invisible"} ${rowClass} col-3`}>
                        {total_amount !== null ? formatAmount(total_amount) : ''}
                        </div>
                        <div className={` ${ rowClass.includes("grand-total") ? "block text-center" :" invisible"} ${rowClass.includes("grand-total") && " "} ${rowClass} col-3`}>
                        {total_amount !== null ? formatAmount(total_amount) : ''}
                        </div>

                            </div>
                        </div>
                        <div className={` ${['section-header',"subsection-header" , "subsubsection-header"].includes(rowClass)  && " invisible"} col-4 text-center  amount `}>
                          
                         <div className=' row'>
                        <div className={` ${ indentClass === "indent-3" ? "block" :" invisible"} col-3`}>  {prev_year_total_amount !== null ? formatAmount(prev_year_total_amount) : ""}</div>
                        <div className={` ${ ["indent-2"].includes(indentClass) ? "block" :" invisible"} ${rowClass} col-3`}>
                        {prev_year_total_amount !== null ? formatAmount(prev_year_total_amount) : ''}
                        </div>
                        <div className={` ${ ["indent-1"].includes(indentClass) ? "block" :" invisible"} ${rowClass} col-3`}>
                        {prev_year_total_amount !== null ? formatAmount(prev_year_total_amount) : ''}
                        </div>
                        <div className={` ${ rowClass.includes("grand-total") ? "block text-center" :" invisible"} ${rowClass.includes("grand-total") && " "} ${rowClass} col-3`}>
                        {prev_year_total_amount !== null ? formatAmount(prev_year_total_amount) : ''}
                        </div>

                            </div>
                        </div>
                       
                    </div>
                );
            };

            return (
                <div ref={ref} className="balance-sheet">
                    <div className="header">
                        <div className="company-name">{payload.companyName}</div>
                        <div className="report-title">{t('balanceSheet')}</div>
                    </div>

                    <div className="container-fluid p-0">
                        <div className="row  d-flex justify-content-center">
                            <div className="col-2 ">
                             
                            </div>
                            <div className="col-5 text-center">
                                <strong>{t('asOf')} {payload.currentDate}</strong>
                            </div>
                            <div className="col-5  text-center">
                                <strong>{t('asOf')} {payload.priorDate}</strong>
                            </div>
                        </div>

                        {payload.data.map((item, index) => renderRow(item, index))}
                    </div>
                </div>
            );
        }
)